import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../services/app.service';

@Component({
  selector: 'app-manual-credit-note',
  templateUrl: './manual-credit-note.page.html',
  styleUrls: ['./manual-credit-note.page.scss'],
})
export class ManualCreditNotePage implements OnInit {
  @Input() public creditselectedIndex: any;
  noname = ""

  public appPages = [
    {
      title: "ค้นหาใบกำกับภาษี",
      url: "/credit-note",
      icon: "mail",
      action: 1,
    },
    {
      title: "เลือกใบกำกับภาษี",
      url: "/credit-select-taxinvoice",
      icon: "paper-plane",
      action: 2,
    },
    {
      title: "ตรวจสอบข้อมูลใบกำกับภาษี",
      url: "/credit-check-taxinvoice",
      icon: "heart",
      action: 3,
    },
    {
      title: "บันทึก และส่งข้อมูล",
      url: "/credit-save-taxinvoice",
      icon: "archive",
      action: 4,
    },
    {
      title: "ออกใบลดหนี้สำเร็จ",
      url: "/credit-note-preview",
      icon: "archive",
      action: 5,
    },
  ];


  constructor(public router: Router, public appService: AppService, private route: ActivatedRoute) {
    console.log("new...", this.creditselectedIndex);
  }

  ngOnInit() {
    this.appService.active.subscribe((value) => {
      console.log("value...", value);
      this.creditselectedIndex = value;
    });
    this.route.queryParams.subscribe((params) => {
      if (params.noName === "no_cn") {
        this.noname = params.noName;
      } else {
        this.noname = "";
      }
    });

  }

  ionViewWillEnter(){
  }

  clickMenu(a) {
    if(a.action == 1){
      this.appService.setActive(a.action);
      this.router.navigate(['/credit-note']);
      if (this.noname !== "") {
        this.router.navigate([a.url], {
          queryParams: { noName: "no_cn", selectedIndex: "4" },
        });
      } else {
        this.router.navigate([a.url]);
      }
    }
  }

}
